module.exports = __webpack_public_path__ + "exo-latin-400.9f16e6ee1e3327b7db3a.woff2";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-400.woff2
// module id = ../../../../typeface-exo/files/exo-latin-400.woff2
// module chunks = styles